import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
  inject,
} from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable, switchMap } from 'rxjs';
import {
  AssetImage,
  ImageThumbnailComponent,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import {
  Route,
  RouteParam,
  RouterLinkComponent,
  RouterLinkParams,
} from '@web/common';
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionPanel,
} from 'primeng/accordion';
import { PublicProductImagesGalleriaComponent } from '../public-product-images-galleria/public-product-images-galleria.component';
import { PublicProductDataSourceService } from '../../services/public-product-data-source.service';
import { PublicProductDetails } from '../../models/public-product-details';
import { SummernoteHtmlPreviewComponent } from '@web/shared/external';
import { isNotNil, valueOrDefault } from '@web/utils';
import {
  PublicCartAddButtonComponent,
  PublicCartQuantityComponent,
} from '@web/shared/module/shop';

@Component({
  selector: 'app-public-product-details',
  imports: [
    Accordion,
    AccordionContent,
    AccordionHeader,
    AccordionPanel,
    CommonModule,
    ImageThumbnailComponent,
    NgOptimizedImage,
    PublicProductImagesGalleriaComponent,
    PublicCartAddButtonComponent,
    PublicCartQuantityComponent,
    RouterLinkComponent,
    SpinnerFilledComponent,
    SummernoteHtmlPreviewComponent,
  ],
  templateUrl: './public-product-details.component.html',
  styleUrl: './public-product-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicProductDetailsComponent {
  /* prettier-ignore */
  private readonly publicCosmeticDataSource = inject(PublicProductDataSourceService);

  public readonly slug = input.required<string>();

  protected readonly slug$ = toObservable(this.slug);
  protected readonly product$ = this.cosmeticSource();
  protected readonly AssetImage = AssetImage;
  protected readonly Route = Route;
  protected readonly RouteParam = RouteParam;
  protected readonly isNotNil = isNotNil;
  protected readonly valueOrDefault = valueOrDefault;
  protected readonly quantity = signal(1);

  public handleQuantityChangeEvent(quantity: number): void {
    this.quantity.set(quantity);
  }

  protected cosmeticDetailsParams(slug: string): RouterLinkParams {
    return {
      [RouteParam.Slug]: slug,
    };
  }

  private cosmeticSource(): Observable<PublicProductDetails> {
    return this.slug$.pipe(
      switchMap((slug) =>
        this.publicCosmeticDataSource.fetchDetailsBySlug(slug),
      ),
    );
  }
}
